import React, { FC } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  Text,
  InputRightElement,
} from '@chakra-ui/react';
import DatePicker from 'react-datepicker';
import { MdCalendarToday } from 'react-icons/md';
import { format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css'; // Ensure you have this CSS import
import { useField } from 'formik';

interface FormikMonthYearPickerProps {
  labelProps?: any;
  name: string;
  onChange?: (month: number, year: number) => void;
}

const FormikMonthYearPickerView: FC<FormikMonthYearPickerProps> = ({
  labelProps,
  onChange,
  name,
}) => {
  const [field, meta, helpers] = useField(name);

  const [selectedDate, setSelectedDate] = React.useState<Date | null>(() => {
    // Initialize with the value from Formik if it exists
    if (field.value) {
      const [month, year] = field.value.split('/');
      if (month && year) {
        return new Date(Number(year), Number(month) - 1, 1);
      }
    }
    return null;
  });

  // Update selectedDate when field.value changes
  React.useEffect(() => {
    if (field.value) {
      const [month, year] = field.value.split('/');
      if (month && year) {
        setSelectedDate(new Date(Number(year), Number(month) - 1, 1));
      }
    } else {
      setSelectedDate(null);
    }
  }, [field.value]);

  return (
    <Box mt={3}>
      <FormLabel {...labelProps} textTransform="capitalize">
        Select Month and Year
      </FormLabel>
      <DatePicker
        dateFormat="MM/yyyy"
        showMonthYearPicker
        selected={selectedDate}
        onChange={(date) => {
          if (date) {
            setSelectedDate(date);
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            const monthYearString = `${month
              .toString()
              .padStart(2, '0')}/${year}`;
            helpers.setValue(monthYearString);
            onChange?.(month, year);
          }
        }}
        customInput={
          <CustomInputDateComponent
            value={selectedDate != null ? format(selectedDate!, 'MM/yyyy') : ''}
          />
        }
      />
      {meta.error && (
        <Text color="red.500" fontSize="sm">
          {meta.touched && meta.error}
        </Text>
      )}
    </Box>
  );
};

type CustomInputDateComponentProps = {
  value: string;
  onClick?: () => void;
};

const CustomInputDateComponent: FC<CustomInputDateComponentProps> = ({
  value,
  onClick,
}) => {
  return (
    <FormControl onClick={onClick} cursor="pointer">
      <InputGroup>
        <Input value={value} readOnly />
        <InputRightElement>
          <MdCalendarToday fill="#2FB64A" />
        </InputRightElement>
      </InputGroup>
    </FormControl>
  );
};

export default FormikMonthYearPickerView;
